export function toBoolean(s: string) : boolean | undefined {
    if (!s) {
        return undefined;
    }
    var s1 = s.toLowerCase();
    switch (s1) {
        case "1":
        case "true":
        case "yes":
            return true;
        case "0":
        case "false":
        case "no":
            return false;
    }
    return undefined;
}
export function toBooleanOrDefault(s: string, defaultValue: boolean) : boolean {
    var b = toBoolean(s);
    if (b === undefined || b === null) {
        return defaultValue;
    }
    return b;
}
export function numberToString(n: number | undefined | null) : string {
    if (n === undefined || n === null || isNaN(n)) {
        return "";
    }
    return n.toString();
}